import api from '@config/api';
import type { SearchQueryParams, SearchResults } from '../types';

export const searchService = {
  search: async (
    params: SearchQueryParams,
    signal?: AbortSignal,
  ): Promise<SearchResults> => {
    const response = await api.get<SearchResults>('/search', {
      params: {
        q: params.q,
        types: params.types?.join(','),
        limit: params.limit,
      },
      signal,
    });
    return response.data;
  },
};
